<template>
    
    <div class="wrap">
        <rotate-detect></rotate-detect><!--  template   -->
        
        <div class="topbar"></div>
        <div class="rightbar"></div>
        <div class="content">
            <nav-bar :nav="showNav"></nav-bar><!--  template   -->
            <section class="artistpage">
              <div class="block"><svg class="svg100" ratio="0.25" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 480"><title>blockwhite</title><polygon points="1920 0 0 480 0 0 1920 0" /></svg></div>
              <div class="main">
                <div class="bookmark"><img src="../asset/svg/bookmark/v/artist.svg" alt="多寶創作人"></div>
                <div class="max1000"><a href="/#/?from_artist" class="arrow_back" onclick="gaclick('btn_artist_back')">
                    <svg class="arrowtop" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.86 18.28"><title>top</title><path d="M33.38,15.63,16,.39a1.57,1.57,0,0,0-2.58,1.15Q7.08,8.78.42,15.73c-1.33,1.38.77,3.49,2.1,2.1Q9.12,11,15.37,3.8l15.9,13.94C32.71,19,34.82,16.9,33.38,15.63Z" /></svg>
                    <svg class="arrowbg"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.86 93.28"><title>btn</title><path d="M0,48.67C-.06,29,12.8,9.5,31,1.79c12.47-5.27,33.3,1.68,39.81,13.45C73.66,20.35,78,24,82.3,27.59c3,2.52,4.79,5.39,4.3,9.48-.39,3.29,1,6.16,2.46,9a15.11,15.11,0,0,1,.18,14c-12.18,25.24-30,34.78-54.36,33a16,16,0,0,1-8.06-2.36C11.93,80.51,0,68.37,0,48.67Z" /></svg></a>
                  <h2 class="artistdescription wow1 fadeInUp"><img src="../img/artist/artistpage1.svg" alt="蒙娜麗莎對我微笑"></h2>
                  <div class="artistinfo">
                    <div class="artistpic wow1 fadeInUp"><img src="../img/artist/artist01.jpg"></div>
                    <div class="txtcontent strip">
                      <h2 class="wow2 fadeInUp"><span>創作人/</span><b>吳柏均</b></h2>
                      <p class="wow3 fadeInUp">「蒙娜麗莎的微笑是世界有名的藝術，全世界沒有人不認識達文西」「我想把蒙娜麗莎的微笑畫的跟達文西一樣好，這樣，全世界的人就會知道我，會跟我做朋友」所以畫好蒙娜麗莎的微笑，就可以有朋友，柏均這樣連結。2014年原本是單純的藝術之旅，到巴黎40
                      天的過程，柏均企圖重建自己新的生命。</p>
                    </div>
                  </div>
                  <div class="worklist">
                    <ul>
                      <li>
                        <div class="featurepic wow1 fadeInUp"><img src="../img/artist/work01_1.jpg" alt=""></div>
                        <h3 class="wow2 fadeInUp">蒙娜麗莎的微笑</h3>
                        <p class="wow3 fadeInUp">80(L) × 53(M)cm (25M) 油畫 2012.</p>
                      </li>
                      <li>
                        <div class="featurepic wow1 fadeInUp"><img src="../img/artist/work01_2.jpg" alt=""></div>
                        <h3 class="wow2 fadeInUp">蒙娜麗莎與我一起微笑</h3>
                        <p class="wow3 fadeInUp">91(L) x 72.5(M)cm (30F) 油畫 2011.</p>
                      </li>
                      <li>
                        <div class="featurepic wow1 fadeInUp"><img src="../img/artist/work01_3.jpg" alt=""></div>
                        <h3 class="wow2 fadeInUp">一輩子畫不完</h3>
                        <p class="wow3 fadeInUp">65(L) x 53(M)cm (15F) 油畫 2013.</p>
                      </li>
                    </ul>
                  </div><a href="javascript:void(0)" class="btn wow4 fadeInUp" onclick="trackWaitJump('btn_moreworks_wubaijun','https:/.wordpress.com/category/%E5%90%B3%E6%9F%8F%E5%9D%87/')">
                    <!--blogicon-->
                    <div class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.24 35.64"><title>read</title><path d="M36.64,0H23.83a4.64,4.64,0,0,0-3.2,1.33A4.64,4.64,0,0,0,17.42,0H4.6A4.67,4.67,0,0,0,0,4.6V27.83a4.67,4.67,0,0,0,4.6,4.6H17.42a1.78,1.78,0,0,1,1.8,1.8,1.4,1.4,0,0,0,1.4,1.4,1,1,0,0,0,.41-.07,1.28,1.28,0,0,0,.82-.63,1.25,1.25,0,0,0,.17-.7,1.78,1.78,0,0,1,1.8-1.8H36.64a4.67,4.67,0,0,0,4.6-4.6V4.6A4.67,4.67,0,0,0,36.64,0ZM22,4.6a1.78,1.78,0,0,1,1.8-1.8H36.64a1.78,1.78,0,0,1,1.8,1.8V27.83a1.78,1.78,0,0,1-1.8,1.8H23.83A4.18,4.18,0,0,0,22,30Zm-2.8,0V30a4.18,4.18,0,0,0-1.8-.41H4.6a1.78,1.78,0,0,1-1.8-1.8V4.6A1.78,1.78,0,0,1,4.6,2.8H17.42A1.78,1.78,0,0,1,19.22,4.6Z" /></svg></div><span>更多柏均的事</span></a>
                  <section class="extra">
                    <div class="txtcontent strip">
                      <h2 class="wow1 fadeInUp"><img src="../img/artist/artistpage1_1.svg" alt="支持柏均以繪畫"><br><img src="../img/artist/artistpage1_2.svg" alt="自食其力的夢想" class="secondtxt"></h2>
                    </div><img src="../img/artist/artist01_dream.jpg" class="wow2 fadeInUp">
                    <article>
                      <h5 class="wow1 fadeInUp">「一張畫像X一個未來」</h5>
                      <p class="wow2 fadeInUp">從小就欣賞寫實風格，達文西的繪畫成就一直是柏均追求的完美。<br><br>「我要把人的神韻、很細微的顏色，一直一直朝著裏面看進去，<br>裏面藏著很多顏色，我想把它畫出來。」<br><br>他一張又一張不斷地畫人像，練習對人的觀察。<br><br>柏均今年大學畢業，支持他「用畫畫工作」，開放各界朋友的委託。<br>為你所愛的人畫一張人像，完成青年以藝術自食其力的夢想。<br><br></p>
                      <div class="entrustinfo wow3 fadeInUp">
                        <h5>委託方式如下</h5>
                        <p><span>尺寸</span>A4</p>
                        <p><span>媒材</span>色鉛筆</p>
                        <p><span>價格</span>2500元/1人</p>
                      </div>
                      <ul class="enterusttips wow4 fadeInUp">
                        <li>提供委託畫像電子檔至<a href="mailto:TCAA@taiwancurio.org.tw">多寶藝術學堂</a></li>
                        <li>填寫姓名、電話、地址、e-mail</li>
                        <li>預付訂金1000元（或全額付清）</li>
                        <li>請確認是否有交件時間的需求</li>
                        <li>註：同一件作品，多一人加1500元</li>
                      </ul>
                    </article>
                  </section>
                </div>
              </div>
              <div class="switchbtn"><router-link to="/artist9" class="btn artist9">
                  <p> <span>創作人/</span><b>藍廷瑋</b></p></router-link><router-link to="/artist2" class="btn artist2" >
                  <p><span>創作人/</span><b>林佳瑄</b></p></router-link></div>

            </section>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import ScrollReveal from 'scrollreveal'
    
    import navBar from './common/Nav.vue'
    import rotateDetect from './common/RotateDetect.vue'

    export default {
      components: {
          navBar,
          rotateDetect
      },
      data: function() {
            return {
               showNav:false
            }
      },
      created: function() {
            //Scrolls to top when view is displayed
            window.scrollTo(0, 0);
      },
      mounted: function(){
          window.sr = ScrollReveal({ reset: true });
            // Customizing a reveal set
          var vv = function(ele,dur,del){
              sr.reveal(ele, { 
                  origin: 'bottom',
                  duration: dur,
                  delay: del,
                  opacity: 0,
                  scale: 1,
                  easing: 'cubic-bezier(0.42, 0, 0.58, 1)',
                  // mobile: true
              });
          }
          vv('.wow1',500,0);
          vv('.wow2',500,200);
          vv('.wow3',500,400);
          vv('.wow4',500,600);

          $('.main').animate({opacity:1});
          gapage('pv_wubaijun');

          $('.logo').on('click',function(){
              window.location="/#/?from_artist";
              gaclick('btn_logo');
          });
      },
      
    }
</script>

<style>
    @import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css';
</style>


// WEBPACK FOOTER //
// Artist1.vue?2bd4229a